



















import { ResearchField } from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ResearchTile from "./ResearchTile.vue";
import TechTile from "./TechTile.vue";

@Component({
  components: {
    ResearchTile,
    TechTile,
  },
})
export default class ResearchTrack extends Vue {
  @Prop()
  field: ResearchField;

  @Prop()
  x: number;
}
